import * as React from 'react';
import { flushSync } from 'react-dom';
import {
  Upload,
  type UploadProps,
} from 'antd';
import type { UploadRequestOption } from './interface';
import AppController from '@/api/seller/Controller/AppController';
import { uniqueId } from 'lodash-es';
import appStore from '@/stores';

type FmsUploadData = {
  locationName?: string;
  region?: 'CN' | 'AU' | 'EU' | 'US';
};

interface FmsUploadType<Values = any> extends UploadProps<Values> {
  dragger?: boolean;
  data?: FmsUploadData | (() => FmsUploadData);
}

const FmsUploadProps = {
  name: 'url',
  customRequest(option: UploadRequestOption) {
    const formData = new FormData();
    if (option.data) {
      const rawData = typeof option.data === 'function' ? (option.data as () => Record<string, unknown>)() : option.data;
      const optionData = {
        ...{
          locationName: appStore?.config?.fmsLocationName //默认fms上传目录
        },
        ...rawData
      } as any;
      Object.keys(optionData).forEach(key => {
        const value = optionData?.[key];
        // support key-value array data
        if (Array.isArray(value)) {
          value.forEach(item => {
            formData.append(`${key}[]`, item);
          });
          return;
        }
        formData.append(key, value as string | Blob);
      });
    }

    // eslint-disable-next-line no-undef
    if (option.file instanceof Blob) {
      formData.append(option.filename as string, option.file, (option.file as any).name);
    } else {
      formData.append(option.filename as string, option.file);
    }
    let abort;
    AppController.fmsUpload(formData, {
      throwError: true,
      getAbort: (fun) => abort = fun,
    }).then((res) => {
      if (res?.status == 1) {
        option.onSuccess?.({
          uid: uniqueId(),
          status: 'done',
          url: `${res.info?.objectURI}`,
          relativeUrl: `${res.info?.relativeObjectURI}`,
        });
      } else {
        option.onError?.(new Error(res?.info));
      }
    }).catch(e => option.onError?.(e));
    return {
      abort,
    };
  },
  onPreview(file: any) {
    if (file.url) {
      window.open(file.url);
    }
  }
};

const FmsUpload = (props: FmsUploadType) => {
  if (props?.dragger) {
    return (
      <Upload.Dragger {...FmsUploadProps}
        {...props}
        onChange={(info) => {
          flushSync(() => {
            props.onChange?.(info);
          });
        }}
      />
    );
  } else {
    return (
      <Upload {...FmsUploadProps}
        {...props}
        onChange={(info) => {
          flushSync(() => {
            props.onChange?.(info);
          });
        }}
      />
    );
  }
};

FmsUpload.LIST_IGNORE = Upload.LIST_IGNORE;

export default FmsUpload;
